import { render, staticRenderFns } from "./LicenseOverlay.vue?vue&type=template&id=ebc0db40&scoped=true"
import script from "./LicenseOverlay.vue?vue&type=script&lang=js"
export * from "./LicenseOverlay.vue?vue&type=script&lang=js"
import style0 from "./LicenseOverlay.vue?vue&type=style&index=0&id=ebc0db40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc0db40",
  null
  
)

export default component.exports